import React from 'react';
import '../svg.css';


const Art = props => {
    const { fill } = props;
    return (
        <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 36 36"
            height="36px"
            width="36px"
            className='svg'
        >
            <g id="messages_art" data-name="messages/art"><g id="Logo"><rect id="frame" className="clsArt-1" width="36" height="36" rx="10"/><path id="Rectangle-25" className="clsArt-2" d="M26,9a3,3,0,0,1,3,3V24a3,3,0,0,1-3,3H10a3,3,0,0,1-3-3V12a3,3,0,0,1,3-3ZM14.94,16.2l-5.5,7.2h11Zm8-3.6a3.6,3.6,0,1,0,3.67,3.6A3.63,3.63,0,0,0,22.89,12.6Z"/></g></g>
        </svg>
    );
};

export default Art;
